export const formatTenderForPickup = ({ validation, actualAmount, currentFloat, ...rest }) => {
  const basePickup = {
    pickedUpAmount: actualAmount ?? currentFloat,
    currentFloat,
    ...rest,
  };
  return basePickup;
};
